
  export default {
    mounted() {
      this.el.addEventListener("keydown", (e) => {
        const keys = ["ArrowLeft", "ArrowRight", "Home", "End"];
        if (!keys.includes(e.key)) return;
        const tabs = Array.from(this.el.querySelectorAll('[role="tab"]'));
        if (tabs.length === 0) return;
        const current = tabs.indexOf(document.activeElement);
        let next;
        if (e.key === "ArrowRight") next = (current + 1) % tabs.length;
        else if (e.key === "ArrowLeft") next = (current - 1 + tabs.length) % tabs.length;
        else if (e.key === "Home") next = 0;
        else next = tabs.length - 1;
        e.preventDefault();
        tabs.forEach((t) => t.setAttribute("tabindex", "-1"));
        tabs[next].setAttribute("tabindex", "0");
        tabs[next].focus();
      });
    }
  }
